/// <amd-module name="Environments/Providers/Kubernetes/KubernetesTelemetryService" />

import { ITelemetryService } from "Environments/Providers/External/Kubernetes/Contracts/Contracts";
import { EnvironmentsTelemetryService } from "Environments/Telemetry/EnvironmentsTelemetryService";
import { IVssPageContext, Services, IVssService } from "VSS/Platform/Context";

export interface IKubernetesTelemetryService extends ITelemetryService, IVssService {}

class KubernetesTelemetryService extends EnvironmentsTelemetryService implements IKubernetesTelemetryService {
    private static FEATURE_AREA = "KubernetesSummaryUI";
    protected pageContext: IVssPageContext;

    public _serviceStart(pageContext: IVssPageContext): void {
        this.pageContext = pageContext;
    }

    public _serviceEnd(pageContext: IVssPageContext): void {}

    public _serviceRestart(pageContext: IVssPageContext): void {
        this.pageContext = pageContext;
    }

    public markTimeToInteractive(scenarioName: string, additionalProperties?: { [key: string]: any; }): void {
        super.markTTI(KubernetesTelemetryService.FEATURE_AREA, scenarioName, additionalProperties);
    }    
    public onClickTelemetry(source: string, additionalProperties?: { [key: string]: any; }): void {
        super.onClickEvent(KubernetesTelemetryService.FEATURE_AREA, source, additionalProperties)
    }
    public scenarioStart(scenarioName: string, additionalProperties?: { [key: string]: any; }): void {
        super.startScenario(scenarioName, additionalProperties);
    }
    public scenarioEnd(scenarioName: string, additionalProperties?: { [key: string]: any; }): void {
        super.endScenario(KubernetesTelemetryService.FEATURE_AREA, scenarioName, additionalProperties);
    }
}

Services.add("IKubernetesTelemetryService", { serviceFactory: KubernetesTelemetryService });